import React from 'react';

const ArrowLeftLarger = props => (
  <img {...props} src={`${MEDIA_ROOT}/icons/icn_arrowleftlarger.svg`} alt="Arrow left" />
);

export default ArrowLeftLarger;
